import DndKitContainer from '@components/testDndKit';
import {
  ClickableIconContainer,
  IconContainer,
  ItemBody,
  StyledInput
} from '@components/testDndKit/sortableItem/sortableItem.style';
import { FormControl, FormLabel, Tooltip } from '@mui/joy';
import type { DndKitValue } from '@stratumn/studio-shared';
import { Check, Pencil } from 'lucide-react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import nanoID from '@/utils/nanoID';

type DndInterfaceProps = {
  values?: DndKitValue[];
  updateValues: (newValues: DndKitValue[]) => void;
  addValue: (value: DndKitValue) => void;
  title: string;
};

const DndInterface = ({
  values,
  updateValues,
  addValue,
  title
}: DndInterfaceProps) => {
  const [newValue, setNewValue] = useState<string>('');

  const resetInput = () => {
    setNewValue('');
  };

  const onEnterDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      addNewValue();
    }
  };

  const addNewValue = () => {
    if (!newValue || newValue === '') {
      return;
    }

    const valueToAdd: DndKitValue = {
      id: nanoID(8),
      name: newValue
    };

    addValue(valueToAdd);
    resetInput();
  };

  return (
    <FormControl size="sm">
      <FormLabel>{title}</FormLabel>
      {!!values?.length && (
        <DndKitContainer dndValues={values} updateValues={updateValues} />
      )}
      <ItemBody>
        <IconContainer>
          <Pencil color="#A4A4A4" size={13} />
        </IconContainer>
        <StyledInput
          data-tag="input-dnd"
          onChange={e => setNewValue(e.target.value)}
          onKeyDown={onEnterDown}
          placeholder="Aa"
          type="text"
          value={newValue}
        />
        <Tooltip
          enterDelay={700}
          placement="bottom"
          title="Or press Enter"
          variant="plain"
        >
          <ClickableIconContainer onClick={addNewValue}>
            <Check color="#A4A4A4" size={15} />
          </ClickableIconContainer>
        </Tooltip>
      </ItemBody>
    </FormControl>
  );
};

export default observer(DndInterface);
